/* eslint-disable max-len */
export default {
  en: {
    issue_description:
      'Describe your problem | Tell us about the problem you are facing, or just create a task.',
    issue: 'Problem | Problems | No problems',
    issue_create: 'Create a problem | Created a problem {at}',
    discussion: 'Discussion | Discussions',
    discussion_no: 'There are no discussions',
    discussion_closed: 'The discussion is closed',
    issueDelete: 'Delete Issue',
    cancel: 'Cancel',
    delete: 'Delete',
    writeCommentTitle: 'Write your comment here',
    issueDeleteConfirmation: 'Are you sure you want to delete the problem?',
    issueNameLabel: 'Title'
  },
  ru: {
    issue_description:
      'Опишите свою проблему | Расскажите о проблеме, с которой вы столкнулись, или просто создайте задачу.',
    issue: 'Проблема | Проблемы | Нет проблем',
    issue_create: 'Создать проблему | Создал проблему {at}',
    discussion: 'Обсуждение | Обсуждения',
    discussion_no: 'Нет дискуссий',
    discussion_closed: 'Дискуссия закрыта',
    issueDelete: 'Удалить проблему',
    cancel: 'Отменить',
    delete: 'Удалить',
    writeCommentTitle: 'Напишите комментарий здесь',
    issueDeleteConfirmation: 'Вы действительно хотите удалить проблему?',
    issueNameLabel: 'Название'
  }
};
